import { InspectionStatus } from "src/data/types";

export type LOADING_STATE = "idle" | "pending" | "fulfilled" | "rejected";

export const DEFAULT_LOCALE = "en";
export const HOMEPAGE_MESSAGE_BUNDLE_NAME = "homepage";

// LDAP Groups for WHSEAP
export const WHS_DATA_EAP_USER_LDAP_GROUP = "whs-data-eap-user";
export const WHS_DATA_EAP_ADMIN_LDAP_GROUP = "whs-data-eap-admin";
export const WORKINGWELL_ENGINEER_LDAP_GROUP = "workingwell-engineer";

// All valid LDAP groups
export const VALID_LDAP_GROUPS = [
  WHS_DATA_EAP_USER_LDAP_GROUP,
  WHS_DATA_EAP_ADMIN_LDAP_GROUP,
  WORKINGWELL_ENGINEER_LDAP_GROUP,
];

// Check if user is admin (has admin or engineer permissions)
export const isAdminUser = (ldapGroups: string[]): boolean => {
  return ldapGroups.some(
    (group) =>
      group === WHS_DATA_EAP_ADMIN_LDAP_GROUP ||
      group === WORKINGWELL_ENGINEER_LDAP_GROUP
  );
};

// Check if user has any valid permissions
export const hasValidPermissions = (ldapGroups: string[]): boolean => {
  return ldapGroups.some((group) => VALID_LDAP_GROUPS.includes(group));
};

// Check if user is an engineer (has dev mode access)
export const isEngineerUser = (ldapGroups: string[]): boolean => {
  return ldapGroups.some((group) => group === WORKINGWELL_ENGINEER_LDAP_GROUP);
};

export const INSPECTION_TABLE_HEADERS = [
  "Inspection",
  "Type",
  "Location",
  "Frequency",
  "Mandate",
  "Status",
];
export const ADD_DETAILS = "add-details";
export const ADD_QUESTIONS = "add-questions";
export const AI = "AI";
export const MANUAL_OVERRIDE = "Manual Override";
export const NON_COMPLIANT = "non_compliant";
export const COMPLIANT = "compliant";
export const compliantStatus = {
  YES: "Yes",
  NO: "No",
};
export const inProgressInspectionStatus = "In_Progress";
export const completedInspectionStatus = "Completed";

export const DEFAULT_SITE_CODE = "ABE2";


/**
 * Extracts the site code (e.g. "ABE2") from a siteLocation string
 * like "ABE2 - Allentown (Allentown, PA)". Splits on the first "-"
 * and returns the trimmed left-hand side.
 */
export const extractSiteCode = (siteLocation: string): string => {
  return siteLocation?.split("-")[0]?.trim() || DEFAULT_SITE_CODE;
};


/**
 * Parses a siteLocation string into a readable format: "BAN12, NASHVILLE, TN".
 *
 * Input format: "BNA12-CO(NASHVILLE,TN,US)"
 * The regex /\(([^)]+)\)/ captures the content inside parentheses —
 * i.e. "NASHVILLE,TN,US" — which is then split into city and state and country(if needed).
 */
export const parseSiteName = (siteLocation: string): string => {
  if (!siteLocation) return DEFAULT_SITE_CODE;

  const siteCode = siteLocation.split("-")[0].trim();
  const match = siteLocation.match(/\(([^)]+)\)/);
  if (!match) return siteCode;
  const [city, state] = match[1].split(",");
  return `${siteCode}, ${city.trim()}, ${state.trim()}`;
};
